export const IS24_ACCOUNT_BASE_PATH = 'https://www.immoscout24.ch/private/account';
export const HG_ACCOUNT_BASE_PATH = 'https://www.homegate.ch';
